import { Component, OnInit, OnDestroy } from '@angular/core';
import { ColumnLayoutSecWidgetComponent } from '../column-layout-sec-widget/column-layout-sec-widget.component';
import { StorerDataService } from '../../../../features/setup/customer/storer/services/storer-data.service';
import { SearchService } from '../../../search/search.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'lfwms-storer-so-default-widget',
  templateUrl: './storer-so-default-widget.html',
  styleUrls: ['./storer-so-default-widget.css']
})
export class StorerSODefaultWidgetComponent extends ColumnLayoutSecWidgetComponent implements OnDestroy {

  public dataService: StorerDataService;
  public searchService: SearchService;
  public primaryDataMap: any;
  public isDataLoaded: boolean = false;
  public widgetPropertyList: Array<string> = [];

  protected initializeWidget() {
    super.initializeWidget();

    this.primaryDataMap = this.cellDataMap;
    this.searchService = this.dataService.getSearchServiceForColumnGroup(this.widgetConfig.id);

    if (this.dataService.displayMode === 'C') {
      this.loadWidgetForCreate();
    } else {
      this.loadWidgetForView();
    }
  }

  private loadWidgetForCreate() {
    this.searchService.fetchMetadata().subscribe(metadata => {
      this.metadataMap = {};
      this.cellDataMap = {};
      this.widgetPropertyList = [];
      metadata.columnList.forEach(column => {
        this.metadataMap[column.propertyName] = column;
        if (column.propertyName !== 'storerKey') {
          this.widgetPropertyList.push(column.propertyName);
        }
      });
      this.filteredMetaData = JSON.parse(JSON.stringify(this.metadataMap));
      this.cellDataMap = this.dataService.createNewRecordForService(this.searchService);
      this.originalCellDataMap = JSON.parse(JSON.stringify(this.cellDataMap));
      this.dataService.cellDataMapByService[this.searchService.searchParams.tableId] = this.cellDataMap;
      this.dataService.metaDataMapByService[this.searchService.searchParams.tableId] = this.metadataMap;
      this.propertyList = this.preparePropertyGrid(this.widgetPropertyList, this.getCellsPerRow());
      this.isDataLoaded = true;
    });
  }

  private loadWidgetForView() {
    const metadataFetch = this.searchService.fetchMetadata();
    const dataFetch = this.searchService.getItemDetailForId(this.searchService.searchParams.idProperty,
      this.primaryDataMap['storerKey'].cVal);

    Observable.forkJoin(metadataFetch, dataFetch).subscribe(response => {
      const metadata = response[0];
      const data: any = response[1];
      this.metadataMap = {};
      this.cellDataMap = {};
      this.widgetPropertyList = [];
      metadata.columnList.forEach(column => {
        this.metadataMap[column.propertyName] = column;
        if (column.propertyName !== 'storerKey') {
          this.widgetPropertyList.push(column.propertyName);
        }
      });
      this.filteredMetaData = JSON.parse(JSON.stringify(this.metadataMap));
      this.propertyList = this.preparePropertyGrid(this.widgetPropertyList, this.getCellsPerRow());

      if (data && data.cells) {
        data.cells.forEach((cell: any) => {
          cell.isEdited = false;
          this.cellDataMap[cell.cName] = cell;
        });
      } else {
        this.cellDataMap = this.dataService.createEmptyRecordForService(this.searchService);
        this.searchService.searchStatus.hasResults = true;
      }
      this.originalCellDataMap = JSON.parse(JSON.stringify(this.cellDataMap));
      this.dataService.cellDataMapByService[this.searchService.searchParams.tableId] = this.cellDataMap;
      this.dataService.metaDataMapByService[this.searchService.searchParams.tableId] = this.metadataMap;
      this.isDataLoaded = true;
    });
  }

  // realigns the widget
  public realignWidget() {
    this.propertyList = this.preparePropertyGrid(this.widgetPropertyList, this.getCellsPerRow());
  }

  public filterMetaData(key: any) {
    return super.filterMetaData(key);
  }

  public ngOnDestroy() {
    this.dataService.cellDataMapByService[this.searchService.searchParams.tableId] = null;
    this.dataService.metaDataMapByService[this.searchService.searchParams.tableId] = null;
  }
}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/storer-so-default-widget/storer-so-default-widget.ts